<script lang="ts" setup>
import type { Category } from '~/models';

import CategoryItem from './CategoryItem.vue';

const props = defineProps<{
  active: Category | null;
  categories: Category[];
}>();

const emits = defineEmits<{
  (e: 'update:active', category: Category): void;
}>();

const { emitEvent: emitGA4Event } = analyticsUtils();

const onClickCategory = (category: Category): void => {
  emitGA4Event('click:category', { name: category.name });
  return emits('update:active', category);
};
</script>

<template>
  <div class="
    grid
    grid-cols-2
    gap-x-2
    gap-y-2
    bg-card/50
    h-fit
    p-2
    overflow-hidden
    backdrop-blur-lg
    category-list
  ">
    <!-- SEO Headings -->
    <h2 v-show="false">Categories</h2>

    <div class="flex flex-col gap-2 col-span-2">
      <slot />
    </div>

    <CategoryItem
      v-for="category of props.categories"
      :key="category.uuid"
      :category="category"
      @click="onClickCategory(category)"
    />
  </div>
</template>

<style lang="scss" scoped>
body.mobile {
  .category-list {
    border-radius: 0;
    min-height: inherit;
  }
}

.category-list {
  border-radius: 0.5rem;
}
</style>
